import { Link } from 'react-router-dom';
import { useTk } from '@/lib/i18n';
import { BottomNav } from '@/components/BottomNav';

/**
 * Koom GO Mini App — 消息中心占位页。
 *
 * 当前 v1 后端尚未实装独立的「消息中心」服务（订单 / 券码 / 活动通知会通过 Telegram Bot 直接触达）。
 * 本页面是 5-tab 底部导航中「消息」入口的目标，遵守 CLAUDE.md「No Mock Data」原则：
 * 不假装拉取消息列表、不展示假装的最近通知，只引导用户去 Telegram Bot 完成同等动作。
 *
 * 待后续 SPEC（消息中心独立模块）落地后，本页会被换成真实的消息列表实现。
 */
export function MessagesPlaceholderPage(): React.ReactElement {
  const tk = useTk();
  return (
    <main className="min-h-screen pb-24">
      <header className="px-5 pt-6 pb-2 bg-neutral-0 border-b border-neutral-100">
        <h1 className="text-lg font-semibold text-neutral-900">{tk('nav.messages')}</h1>
      </header>

      <div className="px-5 pt-10 flex flex-col items-center gap-4 text-center">
        <div className="grid h-16 w-16 place-items-center rounded-full bg-brand-primary-50 ring-2 ring-brand-primary-500">
          <ChatGlyph />
        </div>
        <p className="text-base text-neutral-900 font-medium">
          {tk('messages.placeholder.title')}
        </p>
        <p className="text-sm text-neutral-500 leading-relaxed max-w-xs">
          {tk('messages.placeholder.body')}
        </p>
        <Link
          to="/me/cs"
          className="
            mt-2
            inline-flex items-center gap-2
            rounded-full
            bg-brand-primary-700 px-5 py-2.5
            text-sm font-semibold text-neutral-0
            transition active:scale-[0.97]
          "
        >
          {tk('messages.placeholder.cta_cs')}
        </Link>
      </div>

      <BottomNav />
    </main>
  );
}

function ChatGlyph(): React.ReactElement {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      className="text-brand-primary-700"
    >
      <path d="M21 12a8 8 0 0 1-11.6 7.1L4 21l1.9-5.4A8 8 0 1 1 21 12z" />
      <path d="M8 11h8" />
      <path d="M8 14h5" />
    </svg>
  );
}
